import React from 'react'
import { Field } from 'react-final-form'

import { FREQUENCY_DRIVE_OPTIONS } from '@cinch/oxd-pages/lifestyle/src/constants'

import Tablets from '../fields/tablet/tablet-field.component'

const FrequencyFields: React.FC<{ i18n: Cinch.WebAppTranslations['lifestyle']['frequency'] }> = ({ i18n }) => (
  <Field
    name="drivingFrequency"
    component={Tablets as any}
    label={i18n.drivingFrequency}
    options={FREQUENCY_DRIVE_OPTIONS}
  />
)

export default FrequencyFields
